/* eslint @typescript-eslint/no-unsafe-member-access: 0 */
/* eslint @typescript-eslint/no-explicit-any: 0 */
import { sort, uniq, uniqBy } from "rambda";
import { isNumber } from "./istype";

export function registerArrayMethods() {
  // runTsLintStrictEqualityChecks();

  (Array.prototype as any).orderBy = function <T>(
    this: T[],
    sortFn: ((t: T) => number | string) | ((t: T) => number | string)[],
    ordering?: "asc" | "desc" | ("asc" | "desc")[],
  ): T[] {
    const sortFns = Array.isArray(sortFn) ? sortFn : [sortFn];
    const orderings = Array.isArray(ordering)
      ? ordering
      : ordering
      ? [ordering]
      : [];
    return sort((a, b) => {
      let i = 0;
      for (const sortFn of sortFns) {
        const resA = sortFn(a);
        const resB = sortFn(b);
        const ordering = orderings[i] || "asc";
        const orderingMod = ordering === "asc" ? 1 : -1;
        if (isNumber(resA)) {
          if (resA > (resB as number)) {
            return orderingMod;
          }
          if (resA < (resB as number)) {
            return -orderingMod;
          }
        } else {
          const ord = orderingMod * resA.localeCompare(resB as string);
          if (ord !== 0) {
            return ord;
          }
        }

        i++;
      }
      return 0;
    }, this);
  };

  (Array.prototype as any).compact = function <T>(this: T[]): NonNullable<T>[] {
    return this.filter(
      (t) => t !== null && t !== undefined,
    ) as NonNullable<T>[];
  };

  (Array.prototype as any).uniq = function <T>(this: T[]): T[] {
    return uniq(this);
  };

  (Array.prototype as any).uniqBy = function <T, U>(
    this: T[],
    cb: (t: T) => U,
  ): T[] {
    return uniqBy(cb, this);
  };

  (Array.prototype as any).first = function <T>(this: T[]): T | null {
    return this[0] || null;
  };

  (Array.prototype as any).last = function <T>(this: T[]): T | null {
    return this[this.length - 1] || null;
  };

  (Array.prototype as any).maxBy = function <T>(
    this: T[],
    cb: (t: T) => number,
  ): T | null {
    if (this.length === 0) {
      return null;
    }
    let currMax = this[0];
    let currMaxVal = cb(this[0]);
    for (const a of this) {
      const currVal = cb(a);
      if (currVal > currMaxVal) {
        currMax = a;
        currMaxVal = currVal;
      }
    }
    return currMax;
  };

  (Array.prototype as any).minBy = function <T>(
    this: T[],
    cb: (t: T) => number,
  ): T | null {
    if (this.length === 0) {
      return null;
    }
    let currMin = this[0];
    let currMinVal = cb(this[0]);
    for (const a of this) {
      const currVal = cb(a);
      if (currVal < currMinVal) {
        currMin = a;
        currMinVal = currVal;
      }
    }
    return currMin;
  };

  (Array.prototype as any).take = function <T>(this: T[], n: number): T[] {
    return this.slice(0, n);
  };

  (Array.prototype as any).drop = function <T>(this: T[], n: number): T[] {
    return this.slice(n);
  };

  (Array.prototype as any).groupBy = function <T>(
    this: T[],
    cb: (t: T) => string | number,
  ): { [key: string | number]: T[] } {
    const res: { [key: string | number]: T[] } = {};
    for (const t of this) {
      const key = cb(t);
      if (res[key]) {
        res[key].push(t);
      } else {
        res[key] = [t];
      }
    }
    return res;
  };
}
